import React, { Component } from 'react';
import SelectOperator from './SelectOperator';
import TransTable from './TransTable';

class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      querytype: 'operator',
      queryvalue: '',
      error: '',
    };
  }

  onSelectChange = value => {
    this.setState({
      queryvalue: value,
    });
  };
  render() {
    return (
      <div>
        <SelectOperator onChange={this.onSelectChange} />
        <TransTable
          value={this.state.queryvalue}
          operator={this.state.querytype}
        />
      </div>
    );
  }
}

export default Transactions;



// WEBPACK FOOTER //
// ./src/views/Transactions/Transactions.js